const supportedMatchers: Record< string, string > = {
	error: 'toHaveErrored',
	info: 'toHaveInformed',
	log: 'toHaveLogged',
	warn: 'toHaveWarned',
};

export default supportedMatchers;
